import * as React from "react"
import { SVGProps } from "react"

interface TabbyIconProps extends SVGProps<SVGSVGElement> {
    className?: string
    height?: string | number
    width?: string | number
}

const TabbyIcon: React.FC<TabbyIconProps> = ({
    className,
    height,
    width,
    ...props
}) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlSpace="preserve"
        id="Layer_1"
        x={0}
        y={0}
        height={height}
        width={width}
        style={{
            //@ts-ignore
            enableBackground: "new 0 0 999.4 398.1",
        }}
        viewBox="0 0 999.4 398.1"
        className={className}
        {...props}
    >
        <style>{".st0{fill:#292929}"}</style>
        <linearGradient
            id="SVGID_1_"
            x1={0}
            x2={999.41}
            y1={199.034}
            y2={199.034}
            gradientUnits="userSpaceOnUse"
        >
            <stop
                offset={0}
                style={{
                    stopColor: "#3bff9d",
                }}
            />
            <stop
                offset={1}
                style={{
                    stopColor: "#3bffc8",
                }}
            />
        </linearGradient>
        <path
            d="M922 398.1H77.4C34.7 398.1 0 363.4 0 320.6V77.4C0 34.7 34.7 0 77.4 0H922c42.8 0 77.4 34.7 77.4 77.4v243.2c0 42.8-34.7 77.5-77.4 77.5z"
            style={{
                fill: "url(#SVGID_1_)",
            }}
        />
        <path
            d="m864.9 126.3-53.4 204.1-.2.4H853l53.6-204.5zM203.5 242.4c-5.5 2.9-13 4.6-20.1 4.6-15 0-23.5-2.4-24.4-14.5v-.8c0-.5-.1-1-.1-1.5V195l.1-4.2v-24.9h-.1v-10.6l.1-4.2v-24l-37.2 4.9c25.2-4.9 39.6-24.8 39.6-44.6V75.2h-41.8v57.1l-2.4.7v105.8c1.4 29.7 21 47.4 53.1 47.4 11.4 0 23.9-2.6 33.5-6.9l.2-.1v-37.1l-.5.3z"
            className="st0"
        />
        <path
            d="M210.1 118.6 92.8 136.7v29.7l117.3-18.1zM210.1 162.1 92.8 180.2v28.4l117.3-18.1zM341.6 175.8c-1.7-33-22.3-52.6-55.9-52.6-19.3 0-35.3 7.5-46.1 21.6-10.8 14.1-16.5 34.8-16.5 59.9s5.7 45.9 16.5 59.9c10.8 14.1 26.8 21.6 46.1 21.6 33.6 0 54.3-19.7 55.9-52.9v49.8h41.8V126.6l-41.8 6.4m2.2 71.7c0 29.3-15.4 48.2-39.1 48.2-24.5 0-39.1-18-39.1-48.2 0-30.3 14.6-48.5 39.1-48.5 11.9 0 21.9 4.6 28.8 13.4 6.7 8.7 10.3 20.8 10.3 35.1zM505.3 123.2c-33.7 0-54.3 19.6-55.9 52.7V81.1l-41.8 6.4v195.6h41.8v-49.8c1.6 33.2 22.3 52.9 55.9 52.9 39.4 0 62.9-30.5 62.9-81.5s-23.5-81.5-62.9-81.5zm-19 129.7c-23.8 0-39.1-18.9-39.1-48.2 0-14.3 3.6-26.4 10.3-35 6.9-8.8 16.9-13.4 28.8-13.4 24.5 0 39.1 18.1 39.1 48.5 0 30.1-14.6 48.1-39.1 48.1zM681.9 123.2c-33.7 0-54.3 19.6-55.9 52.7V81.1l-41.8 6.4v195.6H626v-49.8c1.6 33.2 22.3 52.9 55.9 52.9 39.4 0 62.9-30.5 62.9-81.5s-23.5-81.5-62.9-81.5zM663 252.9c-23.8 0-39.1-18.9-39.1-48.2 0-14.3 3.6-26.4 10.3-35 6.9-8.8 16.9-13.4 28.8-13.4 24.5 0 39.1 18.1 39.1 48.5 0 30.1-14.6 48.1-39.1 48.1zM744.9 126.3h44.6l36.3 156.6h-40z"
            className="st0"
        />
    </svg>
)
export default TabbyIcon
